module.exports = __webpack_public_path__ + "static/media/clock.16a597af.svg";